var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayLink)?_c('router-link',{staticClass:"btn-primary action-link",attrs:{"to":_vm.link}},[_vm._v(" "+_vm._s(_vm.hgCurrentStep.actionText)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }